/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hof_Decade_TodayInputs */

const en_hof_decade_today = /** @type {(inputs: Hof_Decade_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Today`)
};

const es_hof_decade_today = /** @type {(inputs: Hof_Decade_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoy`)
};

const de_hof_decade_today = /** @type {(inputs: Hof_Decade_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heute`)
};

const zh_hof_decade_today = /** @type {(inputs: Hof_Decade_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`今天`)
};

const ar_hof_decade_today = /** @type {(inputs: Hof_Decade_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اليوم`)
};

const fr_hof_decade_today = /** @type {(inputs: Hof_Decade_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aujourd'hui`)
};

const vi_hof_decade_today = /** @type {(inputs: Hof_Decade_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hôm nay`)
};

const sw_hof_decade_today = /** @type {(inputs: Hof_Decade_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo`)
};

const th_hof_decade_today = /** @type {(inputs: Hof_Decade_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`วันนี้`)
};

const bs_hof_decade_today = /** @type {(inputs: Hof_Decade_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Danas`)
};

const ja_hof_decade_today = /** @type {(inputs: Hof_Decade_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`今日`)
};

const ko_hof_decade_today = /** @type {(inputs: Hof_Decade_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`오늘`)
};

const pt_hof_decade_today = /** @type {(inputs: Hof_Decade_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoje`)
};

const it_hof_decade_today = /** @type {(inputs: Hof_Decade_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oggi`)
};

const sv_hof_decade_today = /** @type {(inputs: Hof_Decade_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Idag`)
};

const nl_hof_decade_today = /** @type {(inputs: Hof_Decade_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vandaag`)
};

const da_hof_decade_today = /** @type {(inputs: Hof_Decade_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I dag`)
};

const nb_hof_decade_today = /** @type {(inputs: Hof_Decade_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I dag`)
};

const fi_hof_decade_today = /** @type {(inputs: Hof_Decade_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tänään`)
};

const pl_hof_decade_today = /** @type {(inputs: Hof_Decade_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dziś`)
};

const ru_hof_decade_today = /** @type {(inputs: Hof_Decade_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сегодня`)
};

const tr_hof_decade_today = /** @type {(inputs: Hof_Decade_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bugün`)
};

const hi_hof_decade_today = /** @type {(inputs: Hof_Decade_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आज`)
};

const id_hof_decade_today = /** @type {(inputs: Hof_Decade_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hari ini`)
};

const ms_hof_decade_today = /** @type {(inputs: Hof_Decade_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hari ini`)
};

const cs_hof_decade_today = /** @type {(inputs: Hof_Decade_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dnes`)
};

const el_hof_decade_today = /** @type {(inputs: Hof_Decade_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Σήμερα`)
};

const he_hof_decade_today = /** @type {(inputs: Hof_Decade_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`היום`)
};

const af_hof_decade_today = /** @type {(inputs: Hof_Decade_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vandag`)
};

const hu_hof_decade_today = /** @type {(inputs: Hof_Decade_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ma`)
};

/**
* | output |
* | --- |
* | "Today" |
*
* @param {Hof_Decade_TodayInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const hof_decade_today = /** @type {((inputs?: Hof_Decade_TodayInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hof_Decade_TodayInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_hof_decade_today(inputs)
	if (locale === "de") return de_hof_decade_today(inputs)
	if (locale === "zh") return zh_hof_decade_today(inputs)
	if (locale === "ar") return ar_hof_decade_today(inputs)
	if (locale === "fr") return fr_hof_decade_today(inputs)
	if (locale === "vi") return vi_hof_decade_today(inputs)
	if (locale === "sw") return sw_hof_decade_today(inputs)
	if (locale === "th") return th_hof_decade_today(inputs)
	if (locale === "bs") return bs_hof_decade_today(inputs)
	if (locale === "ja") return ja_hof_decade_today(inputs)
	if (locale === "ko") return ko_hof_decade_today(inputs)
	if (locale === "pt") return pt_hof_decade_today(inputs)
	if (locale === "it") return it_hof_decade_today(inputs)
	if (locale === "sv") return sv_hof_decade_today(inputs)
	if (locale === "nl") return nl_hof_decade_today(inputs)
	if (locale === "da") return da_hof_decade_today(inputs)
	if (locale === "nb") return nb_hof_decade_today(inputs)
	if (locale === "fi") return fi_hof_decade_today(inputs)
	if (locale === "pl") return pl_hof_decade_today(inputs)
	if (locale === "ru") return ru_hof_decade_today(inputs)
	if (locale === "tr") return tr_hof_decade_today(inputs)
	if (locale === "hi") return hi_hof_decade_today(inputs)
	if (locale === "id") return id_hof_decade_today(inputs)
	if (locale === "ms") return ms_hof_decade_today(inputs)
	if (locale === "cs") return cs_hof_decade_today(inputs)
	if (locale === "el") return el_hof_decade_today(inputs)
	if (locale === "he") return he_hof_decade_today(inputs)
	if (locale === "af") return af_hof_decade_today(inputs)
	if (locale === "hu") return hu_hof_decade_today(inputs)
	return en_hof_decade_today(inputs)
});